<template>
  <div
    class="absolute top-[25px] right-[75px] bg-g0 flex flex-col p-4 z-50 shadow-2xl"
    style="width: 324px"
  >
    <Map_MapElements_All />
    <div class="flex flex-col">
      <div class="boxs w-full flex-wrap mt-3">
        <div class="col-span-full flex box flex-col !bg-g0 !p-0 text-sm">
          <div class="flex flex-row mb-5 items-center">
            <input
              type="text"
              id="name_mapelement"
              name="name"
              class="px-2 py-1 bg-g2 mr-4 text-white w-full text-sm"
              v-model="name"
              @keyup="changeName"
              required
              :disabled="
                $root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit') === false
              "
            />

            <div
              class="cursor-pointer mr-2"
              @click="zoomToNote"
              :title="$e('Recentrer')"
            >
              <div
                class="w-[20px] fill-current"
                v-html="$root.svg_form_path.center"
              ></div>
            </div>
            <div
              class="cursor-pointer"
              @click="deleteNote"
              :title="$e('Supprimer')"
              v-if="$root.user.can([4, 5], 'CARTE.MAPELEMENTS.delete')"
            >
              <div
                class="w-[20px] fill-current"
                v-html="$root.svg_form_path.delete"
              ></div>
            </div>
          </div>

          <div
            class="flex flex-col mb-5"
            v-if="entity_type === lstMapElementType.Point"
          >
            <div class="boxs grid-cols-2">
              <div class="col-span-full flex flex-col">
                <table
                  class="table-auto"
                  style="border-spacing: 5px; border-collapse: separate"
                >
                  <tbody>
                    <tr class="mt-1">
                      <td>{{ $e("Couleur") }} <small>*</small></td>
                      <td class="flex flex-row justify-between">
                        <input
                          type="checkbox"
                          name="colorMapElement"
                          class="chkCustomStyle"
                          v-for="itm in colors"
                          :key="'chkColorMapElement' + itm.key"
                          :value="itm.col"
                          :style="
                            'border-radius:3px; background-color:' +
                            itm.col +
                            '!important'
                          "
                          :checked="itm.col === color"
                          @change="changeColor(itm.col)"
                          :disabled="
                            $root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit') ===
                            false
                          "
                        />
                      </td>
                    </tr>
                    <tr class="mt-1">
                      <td>{{ $e("Latitude") }} <small>*</small></td>
                      <td>
                        <input
                          type="number"
                          id="lat_mapelement_wgs"
                          name="lat_wgs"
                          class="px-2 py-1 bg-g2 text-white w-full text-sm"
                          v-model.number="lat_wgs"
                          @change="changeLat"
                          required
                          step="0.0001"
                          :disabled="
                            $root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit') ===
                            false
                          "
                        />
                      </td>
                    </tr>
                    <tr class="mt-1">
                      <td>{{ $e("Longitude") }} <small>*</small></td>
                      <td>
                        <input
                          type="number"
                          id="lng_mapelement_wgs"
                          name="lng_wgs"
                          class="px-2 py-1 bg-g2 text-white w-full text-sm"
                          v-model.number="lng_wgs"
                          @change="changeLng"
                          required
                          step="0.0001"
                          :disabled="
                            $root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit') ===
                            false
                          "
                        />
                      </td>
                    </tr>
                    <tr class="mt-1">
                      <td>HAE <small>*</small></td>
                      <td>
                        <input
                          type="number"
                          id="height_mapelement_wgs"
                          name="height_wgs"
                          class="px-2 py-1 bg-g2 text-white w-full text-sm"
                          v-model.number="height_wgs"
                          @change="changeHeightWGS"
                          required
                          step="0.1"
                          :disabled="
                            $root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit') ===
                            false
                          "
                        />
                      </td>
                    </tr>
                    <tr class="mt-1">
                      <td>ASL</td>
                      <td>
                        <input
                          type="number"
                          id="height_mapelement_asl"
                          name="height_asl"
                          class="px-2 py-1 bg-g2 text-white w-full text-sm"
                          v-model.number="height_asl"
                          @change="changeHeightASL"
                          step="0.1"
                          :disabled="
                            $root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit') ===
                            false
                          "
                        />
                      </td>
                    </tr>
                    <tr class="mt-1">
                      <td>AGL</td>
                      <td>
                        <input
                          type="number"
                          id="height_mapelement_agl"
                          name="height_agl"
                          class="px-2 py-1 bg-g2 text-white w-full text-sm"
                          v-model.number="height_agl"
                          @change="changeHeightAGL"
                          step="0.1"
                          :disabled="
                            $root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit') ===
                            false
                          "
                        />
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>

            <div class="mt-2">
              <img src="/assets/images/info/asl-agl-info.svg" alt="Asl & Agl" />
            </div>
          </div>

          <div
            class="flex flex-col mb-5"
            v-if="entity_type === lstMapElementType.Ligne"
          >
            <table
              class="table-auto"
              style="border-spacing: 5px; border-collapse: separate"
            >
              <tbody>
                <tr class="mt-1">
                  <td>{{ $e("Couleur") }} <small>*</small></td>
                  <td class="flex flex-row justify-between">
                    <input
                      type="checkbox"
                      name="colorMapElement"
                      class="chkCustomStyle"
                      v-for="itm in colors"
                      :key="'chkColorMapElement' + itm.key"
                      :value="itm.col"
                      :style="
                        'border-radius:3px; background-color:' +
                        itm.col +
                        '!important'
                      "
                      :checked="itm.col === color"
                      @change="changeColor(itm.col)"
                      :disabled="
                        $root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit') ===
                        false
                      "
                    />
                  </td>
                </tr>
                <tr class="mt-1">
                  <td>{{ $e("Horizontal Distance") }}</td>
                  <td class="flex flex-row justify-between">
                    {{ length_line }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <div
            class="flex flex-col mb-5"
            v-if="entity_type === lstMapElementType.Polygone"
          >
            <table
              class="table-auto"
              style="border-spacing: 5px; border-collapse: separate"
            >
              <tbody>
                <tr class="mt-1">
                  <td>{{ $e("Couleur") }} <small>*</small></td>
                  <td class="flex flex-row justify-between">
                    <input
                      type="checkbox"
                      name="colorMapElement"
                      class="chkCustomStyle"
                      v-for="itm in colors"
                      :key="'chkColorMapElement' + itm.key"
                      :value="itm.col"
                      :style="
                        'border-radius:3px; background-color:' +
                        itm.col +
                        '!important'
                      "
                      :checked="itm.col === color"
                      @change="changeColor(itm.col)"
                      :disabled="
                        $root.user.can([4, 5], 'CARTE.MAPELEMENTS.edit') ===
                        false
                      "
                    />
                  </td>
                </tr>
                <tr class="mt-1">
                  <td>{{ $e("Surface") }}</td>
                  <td class="flex flex-row justify-between">
                    {{ area_poly }}
                  </td>
                </tr>
                <tr class="mt-1">
                  <td>{{ $e("Périmètre") }}</td>
                  <td class="flex flex-row justify-between">
                    {{ length_poly }}
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ref } from "vue";
import { toast } from "vue3-toastify";
import { MapElementType } from "@/utils/constant/settings_constantes";
import API from "@/utils/API";
import Map from "@/utils/Map";
import Map_MapElements_All from "@/partials/Map/Map_MapElements_All.vue";

export default {
  name: "Map_MapElements",
  components: {
    Map_MapElements_All,
  },
  props: {
    currentMapElement: {
      type: Object,
      default: () => {},
    },
  },
  setup() {
    return {
      name: ref("Nouvel élément"),
      color: ref("#2D8CF0"),
      onCreated: ref(false),
      entity_type: ref("Point"),
      height_wgs: ref(0),
      height_asl: ref(0),
      height_agl: ref(0),
      lat_wgs: ref(0),
      lng_wgs: ref(0),
      area_poly: ref(0),
      length_line: ref(0),
      length_poly: ref(0),
      colors: [
        {
          key: "blue",
          col: "#2D8CF0",
        },
        {
          key: "green",
          col: "#19BE6B",
        },
        {
          key: "yellow",
          col: "#FFBB00",
        },
        {
          key: "red",
          col: "#E23C39",
        },
        {
          key: "pink",
          col: "#B620E0",
        },
      ],
      lstMapElementType: MapElementType,
    };
  },
  /*
  watch: {
    currentMapElement: {
      handler: async function (val, oldVal) {
        this.refresh();
        // console.log('Prop changed:', val);
      },
      deep: true,
    },
  },*/

  mounted() {
    // TODO à voir
    // new oWdgCursor("containerFormMapElement");

    const currentInfos = this.currentMapElement.infos;

    if (
      currentInfos !== null &&
      currentInfos !== undefined &&
      currentInfos.id !== null &&
      currentInfos.id !== undefined
    ) {
      this.entity_type = currentInfos.type;

      if (currentInfos.name === "") {
        // cas d'un new item
        this.currentMapElement.setColor(this.color);
        this.currentMapElement.setName(this.name);

        // ADD API
        // récup l'id généré et injecte dans l'obj cesium
        let wkt = this.currentMapElement.getWKT();
        // console.log(wkt);
        this.createMapElement(wkt);
      } else {
        // cas d'un edit
        this.name = currentInfos.name;
        this.color = currentInfos.color;
      }

      /*
      this.currentMapElement.forceUpdateInfos((currentMapElement) => {
        if (this.entity_type === MapElementType.Point) {
          this.lat_wgs = currentMapElement.infos.point.lat.toFixed(8);
          this.lng_wgs = currentMapElement.infos.point.lon.toFixed(8);
          this.height_wgs = currentMapElement.infos.point.height.WGS.toFixed(1);
          this.height_asl = currentMapElement.infos.point.height.ASL.toFixed(1);
          this.height_agl = currentMapElement.infos.point.height.AGL.toFixed(1);
        } else if (this.entity_type === MapElementType.Ligne) {
          this.length_line = this.formatLength(currentMapElement.infos.line.length);
        } else if (this.entity_type === MapElementType.Polygone) {
          this.area_poly = this.formatArea(currentMapElement.infos.polygon.area);
          this.length_poly = this.formatLength(currentMapElement.infos.polygon.length);
        }
      });*/
      this.beforeRefresh();
    }
  },

  unmounted() {
    //TODO IGO unmounted
    /*  //OLD CODE
    Map.clearDraw();
    Map.addDrawOption({});
    Map.getApp().fireTimerClock(); */

    Map.getViewer().canvas.style.cursor = "";
  },

  methods: {
    async createMapElement(geom) {
      let response = await API.post(`mapelement`, {
        name: this.name,
        color: this.color,
        geom: geom,
      });

      if (response?.mae_id !== undefined) {
        this.currentMapElement.setId(response.mae_id);
        this.currentMapElement.updateInfos();
        this.$root.global.refreshPageElement = true;
      } else {
        toast.error(response.Result, this.$root.toastConfig);
      }
    },

    changeColor(col) {
      this.color = col;
      this.currentMapElement.setColor(this.color);
      this.currentMapElement.updateInfos();

      this.saveNote({
        color: this.color,
      });
    },

    changeName() {
      this.currentMapElement.setName(this.name);
      this.currentMapElement.updateInfos();

      this.saveNote({
        name: this.name,
      });
      //}
    },

    changeLat() {
      this.updateDynamic("lat");
    },
    changeLng() {
      this.updateDynamic("lon");
    },
    changeHeightWGS() {
      this.updateDynamic("WGS");
    },
    changeHeightASL() {
      this.updateDynamic("ASL");
    },
    changeHeightAGL() {
      this.updateDynamic("AGL");
    },

    async zoomToNote() {
      let mapelement = Map.element.dynamicmapelements.getById(
        this.currentMapElement.infos.id
      );
      if (
        mapelement != undefined &&
        mapelement !== null &&
        mapelement.dynamic !== undefined
      ) {
        await mapelement.dynamic.forceUpdateInfos(true);
        Map.flyToEntity(mapelement);
      }
    },
    deleteNote() {
      this.$root.confirm_open({
        message:
          this.$e("Voulez-vous vraiment supprimer cet élément de la carte") +
          " '" +
          this.currentMapElement.infos.name +
          "' ?",
        true: async () => {
          await API.put("mapelement", {
            mae_id: this.currentMapElement.infos.id,
            mae_active: "false",
          });

          Map.element.dynamicmapelements.removeById(
            this.currentMapElement.infos.id
          );
          this.$root.global.refreshPageElement = true;
          //this.$router.push({ name: 'MapElements'   });

          Map.toggle_popup_mapelement(false);
          toast.success(
            this.$e("L'élément a été supprimé"),
            this.$root.toastConfig
          );
        },
        false: () => {},
      });
    },

    beforeRefresh() {
      this.lat_wgs = "-";
      this.lng_wgs = "-";
      this.height_wgs = "-";
      this.height_asl = "-";
      this.height_agl = "-";
      this.length_line = "-";
      this.area_poly = "-";
      this.length_poly = "-";
      this.currentMapElement.forceUpdateInfos(true);
    },

    refresh() {
      if (this.name !== this.currentMapElement.infos.name) {
        this.name = this.currentMapElement.infos.name;
        this.beforeRefresh();
      }

      this.height_wgs =
        this.currentMapElement.infos.point.height.WGS.toFixed(1);
      this.height_agl =
        this.currentMapElement.infos.point.height.AGL.toFixed(1);
      this.height_asl =
        this.currentMapElement.infos.point.height.ASL.toFixed(1);
      this.lat_wgs = this.currentMapElement.infos.point.lat.toFixed(8);
      this.lng_wgs = this.currentMapElement.infos.point.lon.toFixed(8);
      this.name = this.currentMapElement.infos.name;
      this.color = this.currentMapElement.infos.color;
      this.area_poly = this.formatArea(
        this.currentMapElement.infos.polygon.area
      );
      this.length_poly = this.formatLength(
        this.currentMapElement.infos.polygon.length
      );
      this.length_line = this.formatLength(
        this.currentMapElement.infos.line.length
      );
      this.entity_type = this.currentMapElement.infos.type;

      Map.getViewer().canvas.style.cursor = "";
    },

    formatArea(area) {
      return area > 1000000
        ? (area / 1000000).toFixed(2) + " km²"
        : area.toFixed(1) + " m²";
    },

    formatLength(length) {
      return length > 1000
        ? (length / 1000).toFixed(2) + " km"
        : length.toFixed(1) + " m";
    },

    saveGeom() {
      let wkt = this.currentMapElement.getWKT();

      this.saveNote({
        geom: wkt,
      });
    },

    updateDynamic(key) {
      this.currentMapElement.infos.point.height.WGS = parseFloat(
        this.height_wgs
      );
      this.currentMapElement.infos.point.height.AGL = parseFloat(
        this.height_agl
      );
      this.currentMapElement.infos.point.height.ASL = parseFloat(
        this.height_asl
      );
      this.currentMapElement.infos.point.lat = parseFloat(this.lat_wgs);
      this.currentMapElement.infos.point.lon = parseFloat(this.lng_wgs);
      this.currentMapElement.updateInfos(key);
      this.refresh();
      this.saveGeom();
    },

    async saveNote(params) {
      let response = await API.put("mapelement", {
        mae_id: this.currentMapElement.getId(),
        ...params,
      });

      if (
        response !== undefined &&
        response !== null &&
        response.Result !== ENV.API_RESPONSE_VALID
      ) {
        toast.error(response.Result, this.$root.toastConfig);
      } else {
        this.$root.global.refreshPageElement = true;
      }
    },
  },
};
</script>
